<template>
  <div>
    <v-layout row wrap>
      <v-spacer />
      <companyAccountTransferForm :companyBalance="companyBalance" />
    </v-layout>
    <v-layout
      v-if="received_transfers.length === 0 && emitted_transfers.length === 0"
      justify-center
      ma-5
    >
      <span class="caption pl-4">
        <v-icon color="primary" small class="pr-2">info</v-icon>This company
        account has no transfer yet.
      </span>
    </v-layout>

    <v-data-table v-else :headers="headers" :items="all_transfers">
      <template v-slot:items="props">
        <td class="text-xs-left">{{ timeToDate(props.item.date) }}</td>
        <td class="text-xs-left">{{ props.item.company_name }}</td>
        <td class="text-xs-left error--text">
          <strong>{{ props.item.debit }}</strong>
        </td>
        <td class="text-xs-left success--text">
          <strong>{{ props.item.credit }}</strong>
        </td>
        <td class="text-xs-left">{{ props.item.notes }}</td>
        <td class="text-xs-left">
          <destroyModale
            :icon="true"
            :small_icon="true"
            :fab="false"
            resourceName="company_balance_transfer"
            :itemId="props.item.id"
            warningText="You are going to remove this <b>Account Transfer</b> permanently.<br>This action can't be undone."
            small
            color="ctcRed"
          />
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import companyAccountTransferForm from "./companyAccountTransferForm";
import currency from "../../../mixins/currency";
import JsonViewer from "vue-json-viewer";
import date from "../../../mixins/date.js";
export default {
  name: "companyAccountTransfersIndex",
  components: { companyAccountTransferForm, JsonViewer },
  mixins: [currency, date],
  props: {
    companyBalance: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Date",
          align: "left",
          sortable: true,
          value: "date",
        },
        {
          text: "Company",
          align: "left",
          sortable: true,
          value: "company_name",
        },
        {
          text: "Debit",
          align: "left",
          sortable: true,
          value: "debit",
        },
        {
          text: "Credit",
          align: "left",
          sortable: true,
          value: "credit",
        },
        {
          text: "Notes",
          align: "left",
          sortable: false,
          value: "notes",
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "",
        },
      ],
    };
  },
  computed: {
    emitted_transfers() {
      return this.companyBalance.emitter_company_balance_transfers.map((e) => {
        return {
          id: e.id,
          amount: e.emitter_amount,
          balance_name: e.recipient_company_balance.company_name,
        };
      });
    },
    received_transfers() {
      return this.companyBalance.recipient_company_balance_transfers.map(
        (e) => {
          return {
            id: e.id,
            amount: e.recipient_amount,
            balance_name: e.emitter_company_balance.company_name,
          };
        }
      );
    },
    all_transfers() {
      var tempRecipients = this.companyBalance.recipient_company_balance_transfers.map(
        (e) => {
          return {
            id: e.id,
            debit: "",
            credit: e.recipient_amount,
            company_name: e.emitter_company_balance.company_name,
            date: e.recipient_transfer_date,
            notes: e.notes,
          };
        }
      );

      var tempEmmiters = this.companyBalance.emitter_company_balance_transfers.map(
        (e) => {
          return {
            id: e.id,
            debit: e.emitter_amount,
            credit: "",
            company_name: e.recipient_company_balance.company_name,
            date: e.emitter_transfer_date,
            notes: e.notes,
          };
        }
      );

      return tempRecipients.concat(tempEmmiters);
    },
  },
  methods: {},
  watch: {},
};
</script>
